
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex'

@Options({
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  }
})
export default class AboutUs extends Vue {}
